import { render, staticRenderFns } from "./concept2.vue?vue&type=template&id=8a9bd3d8&scoped=true&"
import script from "./concept2.vue?vue&type=script&lang=js&"
export * from "./concept2.vue?vue&type=script&lang=js&"
import style0 from "./concept2.vue?vue&type=style&index=0&id=8a9bd3d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9bd3d8",
  null
  
)

export default component.exports